module.exports = __webpack_public_path__ + "img/back pocket width welt.b65cffc5.png";